// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"28ea0f50","246":"b3f72bb2"}[chunkId] + ".chunk.js";
};